var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-3 align-self-center" }, [
          _c(
            "h1",
            { staticClass: "mb-3", staticStyle: { "margin-top": "30px" } },
            [_vm._v("Quem Somos")]
          ),
        ]),
        _c("div", { staticClass: "col-md-8 my-3" }, [
          _c("p", [
            _vm._v(
              " Somos uma empresa tecnológica e com muita humanização, dedicada a segmentos do call center. Em constante inovação, com foco total nas atualizações de mercado. Sempre em busca do atendimento de excelência que resulta em resultados efetivos nas operações. Nossos clientes já sabem: construímos uma reputação inquestionável por conta do compromisso com a ética e com desfechos positivos. Não por acaso, grandes empresas e corporações também são nossas parceiras habituais. Evoluir e reinventar-se: não temos medo de mudar. Essa convicção nos move e ocorre porque atuamos com planejamento, nunca com improviso. E mais: com pessoal treinado e motivado. É o nosso grande time de colaboradores que muito nos orgulha pela garra, pela disciplina e pela proatividade. É precioso constatar que, com trabalho bem feito, todos os partícipes saem satisfeitos. "
            ),
          ]),
          _c("hr"),
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(" Endereço Matriz: "),
            _c("br"),
            _vm._v(
              "R. Antônio Alves, 29-16 - Bauru - São Paulo - CEP 17012-431 Endereço "
            ),
            _c("br"),
            _c("br"),
            _vm._v("Filial 1: "),
            _c("br"),
            _vm._v(
              "Rua Eduardo Ruiz Cobo, 0-1856 - Pederneiras - SP - CEP 17280-000 "
            ),
            _c("br"),
            _c("br"),
            _vm._v("Endereço Filial 2: "),
            _c("br"),
            _vm._v("Rua Antônio Alves, 34-27 - Bauru - SP - CEP 17012-431 "),
          ]),
          _c(
            "a",
            {
              staticClass: "btn btn-link",
              attrs: { href: "tel:+55143235-0900" },
            },
            [
              _c("i", { staticClass: "fa fa-phone fa-fw mx-1 fa-lg" }),
              _vm._v("(xx) xxxx-xxxx"),
            ]
          ),
          _c("br"),
          _c(
            "a",
            {
              staticClass: "btn btn-link",
              attrs: { href: "mailto:xxxx@xxxx.com", target: "_blank" },
            },
            [
              _c("i", { staticClass: "fa fa-envelope-o fa-fw mx-1 fa-lg" }),
              _vm._v("xxxx@xxxx.com"),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }